export const NEW_NOTE = '/new/note'
export const NEW_TASK = '/new/task'
export const NEW_BOOKMARK = '/new/bookmark'
export const HOME = '/home'
export const LEARN_MORE = '/learn-more'
export const SIGN_IN = '/signin'
